var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"editModal",attrs:{"centered":"","title":_vm.title && _vm.title,"ok-title":_vm.$t(_vm.tKey + 'saveOk'),"cancel-title":_vm.$t(_vm.tKey + 'saveCancel'),"ok-variant":"success"},on:{"ok":function($event){return _vm.$emit('save')}}},[_c('p',{staticClass:"lead",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.tKey + 'saveWarning'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }